module.exports = __webpack_public_path__ + "img/attack.3856f1fe.svg";